export default __webpack_public_path__ + "static/media/12.e4d200e1.jpg";